import React, { useState } from 'react';
import './OrderAuditTimeline.css';

// ── Helpers ────────────────────────────────────────────────────────

function formatRelativeTime(timestamp) {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now = new Date();
  const diff = now - date;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'ahora';
  if (mins < 60) return `hace ${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `hace ${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `hace ${days}d`;
  return date.toLocaleDateString('es-MX', { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatFieldLabel(field) {
  const labels = {
    // Bread order fields
    firstName: 'Nombre',
    lastName: 'Apellido',
    phoneNumber: 'Telefono',
    date: 'Fecha',
    time: 'Hora',
    bread: 'Pan',
    comments: 'Comentarios',
    cashier: 'Cajero/a',
    status: 'Estado',
    // Cake order fields
    cakeSize: 'Tamano',
    filling1: 'Relleno',
    filling2: 'Relleno 2',
    color: 'Color',
    message: 'Dedicatoria',
    image: 'Imagen',
    ready: 'Listo',
    imageReady: 'Imagen Lista',
    prePaid: 'Pre-pagado',
    imageNeeded: 'Necesita Imagen',
    imageUrl: 'URL Imagen',
    createdImageUrl: 'URL Imagen Creada',
    // Soft delete fields
    deleted: 'Eliminado',
    deletedBy: 'Eliminado por',
    deletedAt: 'Eliminado el',
  };
  return labels[field] || field;
}

function formatValue(field, value) {
  if (value === null || value === undefined) return '\u2014';
  if (field === 'ready' || field === 'imageReady' || field === 'prePaid' || field === 'deleted' || field === 'imageNeeded') {
    return value ? 'Si' : 'No';
  }
  if (field === 'status') {
    const statusLabels = { pending: 'Pendiente', baked: 'Horneado', completed: 'Completado' };
    return statusLabels[value] || value;
  }
  if (typeof value === 'string' && value.length > 100) {
    return value.substring(0, 100) + '...';
  }
  if (Array.isArray(value)) {
    return value.map(v => (typeof v === 'object' && v !== null) ? `${v.quantity}x ${v.bread}` : v).join(', ') || '\u2014';
  }
  return String(value);
}

// ── Component ──────────────────────────────────────────────────────

export default function OrderAuditTimeline({ auditLog }) {
  const [expanded, setExpanded] = useState(false);

  if (!auditLog || auditLog.length === 0) return null;

  const visible = expanded ? auditLog : auditLog.slice(0, 5);

  return (
    <div className="order-audit-section">
      <div className="order-audit-label">Historial de Cambios</div>
      <div className="order-audit-timeline">
        {visible.map((entry) => (
          <div key={entry.id} className="order-audit-entry">
            <div className="order-audit-dot" />
            <div className="order-audit-content">
              <div className="order-audit-meta">
                <span className="order-audit-time">{formatRelativeTime(entry.timestamp)}</span>
                <span className="order-audit-user">{entry.user_email}</span>
              </div>
              <div className="order-audit-changes">
              {entry.action === 'created' ? (
                <span className="order-audit-action">Creado</span>
              ) : entry.action === 'deleted' ? (
                <span className="order-audit-action order-audit-action--deleted">Eliminado</span>
              ) : (
                Object.entries(entry.changes).map(([field, change]) => (
                  <span key={field} className="order-audit-change-line">
                    {formatFieldLabel(field)}:{' '}
                    <span className="order-audit-old">{formatValue(field, change.old)}</span>
                    {' \u2192 '}
                    <span className="order-audit-new">{formatValue(field, change.new)}</span>
                  </span>
                ))
              )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {auditLog.length > 5 && !expanded && (
        <button
          className="order-audit-more"
          onClick={() => setExpanded(true)}
          type="button"
        >
          Ver historial completo ({auditLog.length} cambios) &rarr;
        </button>
      )}
    </div>
  );
}
